export default __webpack_public_path__ + "static/media/i_x_w.bd889b9f.svg";